import React from 'react';
import { Ticket, Clock, CheckCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const StatsOverview = ({ statistics }) => {
  const statCards = [
    {
      label: 'Total Tickets',
      value: statistics?.total || 0,
      icon: Ticket,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Open',
      value: statistics?.byStatus?.open || 0,
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50'
    },
    {
      label: 'In Progress',
      value: statistics?.byStatus?.in_progress || 0,
      icon: Clock,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    },
    {
      label: 'Resolved',
      value: statistics?.byStatus?.resolved || 0,
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => {
        const Icon = stat?.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-5"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">{stat?.label}</p>
                <p className="text-2xl font-bold text-gray-900">{stat?.value}</p>
              </div>
              <div className={`${stat?.bgColor} ${stat?.color} p-3 rounded-lg`}>
                <Icon className="w-6 h-6" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsOverview;